// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, IconButton, MenuItem, Box, MenuList, Typography} from '@material-ui/core';
import IconUp from '@material-ui/icons/ArrowUpward';
import IconDown from '@material-ui/icons/ArrowDownward';
import IconDelete from '@material-ui/icons/Delete';
//import Fields from './Fields';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow:1,
	},
  	table: {
    	minWidth: 650,
		maxHeight:'calc(100vh - 64px)',
		//maxHeight: '100%'
	},
    fieldlist : {
        minWidth: 200,
        minHeight: 300,
        maxHeight : 500,
        overflow: 'auto'
    },
    listcontrols : {
        display: 'flex',
        flexDirection : 'column',
        width: 50
    }
}));


export default function ViewEditor(props) {
    //inherit view and view setter from parent
    const {view, setView, fields} = props;
    //currently selected column name (dev name)
    const [selected, setSelected] = React.useState(null);
    //all available fields
    const allFields = fields();
    //create classees
    const classes = useStyles();

    //on select a column to add
    const handleAddField = (e) => {
        //name of the field
        let fieldname = e.target.value;
        //get the basic properties of the field
        let field = allFields.find(n => n.name === fieldname);
        //copy the view
        let newView = Object.assign({}, view);
        //add field to view
        newView.lv_fields.push({
            name : fieldname,
            label : field.label
        });
        //update the view
        setView(newView);
    }

    //move column up in list
    const handleMoveUp = (e) => {
        //only if selected
        if(!selected) return false;
        //get index of selected field
        let index = view.lv_fields.findIndex(n => n.name === selected);
        //can't move up past 0
        if(index === 0) return false;
        //copy the view
        let newView = Object.assign({}, view);
        //remove element from current position
        let field = newView.lv_fields.splice(index, 1)[0];
        //put it back one step up
        newView.lv_fields.splice(index - 1, 0, field);
        //update the view
        setView(newView);
    }

    //move column down in list
    const handleMoveDown = (e) => {
        //only if a column is selected
        if(!selected) return false;
        //get the current position of field
        let index = view.lv_fields.findIndex(n => n.name === selected);
        //check if already at bottom
        if(index === view.lv_fields.length - 1) return false;
        //copy the view
        let newView = Object.assign({}, view);
        //remove element from list
        let field = newView.lv_fields.splice(index, 1)[0];
        //put it back one step down
        newView.lv_fields.splice(index + 1, 0, field);
        //update the view
        setView(newView);
    }

    //remove column from list
    const handleRemove = (e) => {
        if(!selected) return false;
        //get column position
        let index = view.lv_fields.findIndex(n => n.name === selected);
        //copy the view
        let newView = Object.assign({}, view);
        //remove from list
        newView.lv_fields.splice(index, 1);
        //deselect
        setSelected(null);
        //update the view
        setView(newView);
    }

    //Update column label
    const handleChangeFieldLabel = (e) => {
        //only if a column is selected
        if(!selected) return false;
        //get index of selected column
        let index = view.lv_fields.findIndex(n => n.name === selected);
        //copy the view
        let newView = Object.assign({}, view);
        //update label
        newView.lv_fields[index].label = e.target.value;
        //update view
        setView(newView);
    }

    //Update column custom attributes
    const handleChangeFieldEdit = (e) => {
        if(!selected) return false;
        //get index of selected column
        let index = view.lv_fields.findIndex(n => n.name === selected);
        //copy the view
        let newView = Object.assign({}, view);
        //update variable
        newView.lv_fields[index][e.target.name] = e.target.value;
        //update view
        setView(newView);
    }

    //compile selected column edit options
    const fieldOptions = () => {
        if(!selected) return (<Typography>No column selected</Typography>);
        //get the selected field
        let field = view.lv_fields.find(n => n.name === selected);
        //get the field class
        let basefield = allFields.find(n => n.name === selected);
        //render selected field options
        return (
            <Box id="fieldoptions" display="flex">
                <Box id="fieldcontrols" className={classes.listcontrols}>
                    <IconButton onClick={handleMoveUp}>
                        <IconUp />
                    </IconButton>
                    <IconButton onClick={handleRemove}>
                        <IconDelete />
                    </IconButton>                        
                    <IconButton onClick={handleMoveDown}>
                        <IconDown />
                    </IconButton>
                </Box>
                <Box id="fieldsettings">
                    <TextField
                        id="field_name"
                        label="Dev name"
                        name="name"
                        value={field.name}
                        disabled={true}
                        fullWidth
                   />
                   <TextField
                        id="field_label"
                        label="Column Label"
                        name="label"
                        value={field.label || basefield.label}
                        onChange={handleChangeFieldLabel}
                        fullWidth
                    />
                    {basefield.edit(field, handleChangeFieldEdit)}
                </Box>
            </Box>
        );
    }

    //render column manager
    return (
        <Box id="fields">
            <Box id="addfield">
                <TextField
                    id="add_field"
                    label="Add Column..."
                    value={null}
                    onChange={handleAddField}
                    fullWidth
                    select
                >
                {allFields.filter(n => n.type !== 'HIDDEN' && !view.lv_fields.find(f => n.name === f.name)).map((field, i) => (
                    <MenuItem value={field.name} key={i}>{field.label}</MenuItem>
                ))}
                </TextField>
            </Box>
            <Box id="fieldcontrol" display="flex">
                <Box id="fieldlist" className={classes.fieldlist}>
                    <MenuList>
                        {view.lv_fields.map((field, i) => (
                            <MenuItem 
                                onClick={e => setSelected(field.name)} 
                                value={field.name} selected={field.name === selected} 
                                key={i}>{field.label || allFields.find(f => f.name === field.name).label}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Box>
                {fieldOptions()}
            </Box>
        </Box>
    );
}
